// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__AXoXI","slider":"Switch_slider__wnOAX","round":"Switch_round__nn2jH","switch-wrapper":"Switch_switch-wrapper__p14BI","disabled":"Switch_disabled__AS74+"};